import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Wraps the product form buttons (stepper, add-to-cart, accelerated checkout).
 * When Pre-Orders offer mode is active, listens for variant updates and hides
 * itself if the selected variant is sold out. Does nothing when the mode is off.
 *
 * @extends {Component}
 */
class PreorderBuyButtonsToggle extends Component {
  #target = null;

  connectedCallback() {
    super.connectedCallback();
    if (this.dataset.preorderModeActive !== 'true') return;

    this.#target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card, .shopify-section');
    if (!this.#target) return;
    this.#target.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (!this.#target) return;
    this.#target.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
    this.#target = null;
  }

  #onVariantUpdate = (event) => {
    if (event.detail?.data?.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.detail?.data?.productId && event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const variant = event.detail?.resource;
    const isSoldOut = !variant || variant.available === false;

    if (isSoldOut) {
      this.setAttribute('hidden', '');
    } else {
      this.removeAttribute('hidden');
    }
  };
}

if (!customElements.get('preorder-buy-buttons-toggle')) {
  customElements.define('preorder-buy-buttons-toggle', PreorderBuyButtonsToggle);
}
